<template>
  <section class="section-hero sectionBackGround">
    <div class="container">
      <div class="row justify-content-center align-items-center">
        <div class="col-lg-12 text-center">
          <card gradient="secondary" shadow body-classes="p-lg-5" class="position-relative" style="margin-top: 20px;">

            <div class="row" style="color: gray;">
              <div class="col-1 col-md-1">
                <!-- 左上角返回图标 -->
                <div class="badge-icon position-absolute back-button-container" @click="goBack" style=" width: 50px;">
                  <i class="fa fa-angle-left" style="color: gray;"></i>
                  <span>返回</span>
                </div>

              </div>
              <div class="col-12 col-md-12">
                <h4 class="mb-1 doc-title">
                  <!-- 文献详情标题 -->
                  {{ documentDetail.articletitle || '加载中...' }}
                </h4>
              </div>
            </div>

            <!-- 标签展示 -->
            <div class="row" style="color: gray;">
              <div class="col-5 col-md-2 p-10">
                <div class="d-flex align-items-center">
                  <badge type="" circle icon="fa fa-circle-o-notch"></badge>
                  <h6 class="mb-0 mr-1" style="color: #7D7E80; font-family: 'Noto Sans S Chinese'; font-size: 12px; font-weight: 400; line-height: 20px;">文献标签 </h6>
                </div>
              </div>
              <div class="col-7 col-md-10 text-left p-1" style="margin-left: -30px;">
                <badge style="color: #7D7E80; 
                    background-color: #ECEDEF; 
                    font-family: 'Noto Sans S Chinese'; font-size: 12px; font-weight: 400; line-height: 14px;">
                      {{ documentDetail.articletags || '无标签' }}
                  </badge>
              </div>
            </div>

            <!-- 文章链接 -->
            <div class="row" style="color: gray;">
              <div class="col-5 col-md-2">
                <div class="d-flex align-items-center">
                  <badge type="" circle icon="fa fa-link" style="color: gray;"></badge>
                  <h6 class="mb-0 mr-1" style="color: #7D7E80; font-family: 'Noto Sans S Chinese'; font-size: 12px; font-weight: 400; line-height: 20px;">链接</h6>
                </div>
              </div>
              <div class="col-7 col-md-10 text-left p-1" style="margin-left: -30px;">
                <h6 class="mb-0 mr-1" style="color: #7D7E80; font-family: 'Noto Sans S Chinese'; font-size: 12px; font-weight: 400; line-height: 30px;">
                  <a style="color: gray;" :href="documentDetail.articleurl" target="_blank"
                    v-if="documentDetail.articleurl">
                    {{ documentDetail.articleurl }}
                  </a>
                  <span v-else>无链接</span>
                </h6>
              </div>
            </div>

            <!-- 推荐评分 -->
            <div class="row" style="color: gray;">
              <div class="col-5 col-md-2">
                <div class="d-flex align-items-center">
                  <badge type="" circle icon="fa fa-star-o" style="color: gray;"></badge>
                  <h6 class="mb-0" style="color: #7D7E80; font-family: 'Noto Sans S Chinese'; font-size: 12px; font-weight: 400; line-height: 20px;">推荐评分 </h6>
                </div>
              </div>
              <div class="col-7 col-md-10 text-left p-1" style="margin-left: -30px;color: #7D7E80; font-family: 'Noto Sans S Chinese'; font-size: 12px; font-weight: 400; line-height: 30px;">
                {{ documentDetail.recommendationscore || '无评分' }}
              </div>
            </div>

            <!-- 研究方式 -->
            <div class="row" style="color: gray;">
              <div class="col-5 col-md-2">
                <div class="d-flex align-items-center">
                  <badge type="" circle class="mr-0" icon="fa fa-flask"></badge>
                  <h6 class="mb-0" style="color: #7D7E80; font-family: 'Noto Sans S Chinese'; font-size: 12px; font-weight: 400; line-height: 20px;">研究方式 </h6>
                </div>
              </div>
              <div class="col-7 col-md-10 text-left p-1" style="margin-left: -30px;color: #7D7E80; font-family: 'Noto Sans S Chinese'; font-size: 12px; font-weight: 400; line-height: 30px;">
                {{ documentDetail.researchmethod || '未知' }}
              </div>
            </div>

            <hr style="margin: 10px;height:1px" />
            <!-- 文献摘要 -->
            <div class="row" style="color: gray;">
              <div class="col-5 col-md-2">
                <div class="d-flex align-items-center">
                  <badge type="" circle icon="fa fa-sticky-note-o"></badge>
                  <h6 class="mb-0" style="color: #7D7E80; font-family: 'Noto Sans S Chinese'; font-size: 12px; font-weight: 400; line-height: 20px;">文献摘要</h6>
                </div>
              </div>
              <div class="col-7 col-md-10 text-left p-1" style="margin-left: -30px;color: #7D7E80; font-family: 'Noto Sans S Chinese'; font-size: 12px; line-height: 20px;">
                <div v-html="documentDetail.articleabstract"></div>
                <!-- {{ documentDetail.articleabstract || '暂无摘要' }} -->
              </div>
            </div>

            <hr style="height:1px" />
            <!-- 管理员评论 -->
            <div class="row" style="color: gray;">
              <div class="col-5 col-md-2">
                <div class="d-flex align-items-center">
                  <badge type="" circle icon="fa fa-pencil-square-o" style="color: gray;"></badge>
                  <h6 class="mb-0" style="color: #7D7E80; font-family: 'Noto Sans S Chinese'; font-size: 12px; font-weight: 400; line-height: 20px;">XX评论</h6>
                </div>
              </div>
              <div class="col-7 col-md-10 text-left p-1" style="margin-left: -30px;color: #7D7E80; font-family: 'Noto Sans S Chinese'; font-size: 12px; font-weight: 400; line-height: 30px;">
                {{ documentDetail.admincomment || '暂无评论' }}
              </div>
            </div>

            <hr style="height:1px" />

            <div class="row">
              <div class="col-5 col-md-10">
                <span>
                  <div class="d-flex align-items-center">
                    <badge type="" circle icon="fa fa-star-o"></badge>
                    <h6 class="mb-0" style="color: #7D7E80; font-family: 'Noto Sans S Chinese'; font-size: 12px; line-height: 30px;">{{ formattedDate(documentDetail.updatetime) }}</h6>
                  </div>
                </span>
              </div>
              <div class="col-7 col-md-2">
                <span>
                  <div class="d-flex align-items-center">
                    <badge type="" circle icon="fa fa-star-o"></badge>
                    <h6 class="mb-0" style="color: #7D7E80; font-family: 'Noto Sans S Chinese'; font-size: 12px; line-height: 30px;">收藏</h6>
                  </div>
                </span>
              </div>
            </div>

            <!-- 推荐评分 -->

          </card>
<br/>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
export default {
  data() {
    return {
      searchQuery: '',
      documentDetail: {}, // 存储文献详情
      searchResults: [],   // 保存从列表页传递过来的搜索结果
      page: 1,  // 添加 page 字段
    };
  },
  created() {
    const id = this.$route.query.id;
    this.searchQuery = this.$route.query.searchQuery || '';
    this.page = this.$route.query.page || 1;  // 保存页码
    
    const token = this.getCookie('token');
    if (!token) {
      this.$router.push('/login');
      return;
    }
    if (id) {
      this.fetchDocumentDetail(id, token);
    }
  },
  methods: {
    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    },
    goBack() {
      // this.$router.push({
      //   name: "DocQueryList",
      //   params: { searchResults: this.searchResults }
      // });

      this.$router.push('/DocQueryList?searchQuery=' + this.searchQuery + '&page=' + this.page);

    },
    async fetchDocumentDetail(id, token) {
      try {
        const params = new URLSearchParams();
        params.append('token', token);
        params.append('id', id);

        const response = await axios.post('https://anthromindxx.com/ca.php?action=get_item_detail', params, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });

        if (response.data) {
          this.documentDetail = response.data;
        } else {
          this.$router.push('/AboutUs');
        }
      } catch (error) {
        //console.error('Error fetching document detail:', error);
        alert('获取文档详情时发生错误，请重试。');
      }
    },
    formattedDate(value) {
      return moment(value).format('YYYY-MM-DD');
    },
  }
};
</script>

<style scoped>
.sectionBackGround {
  background-color: black;
  /* 使内容区域填充剩余空间 */
  min-height: calc(100vh - 48px);
  /* 确保内容区域至少与视口高度减去头部高度一样大 */
  background-image: url('https://anthromindxx.com/ant/BK.png');
  /* 设置背景图路径 */
  background-position: center center;
  /* 背景图片位置 */
  background-attachment: fixed;
  /* 背景图片相对于视口固定 */
  background-size: 100% 100%;
  /* 背景图片根据元素大小缩放 */
  overflow-y: auto;
  /* 在内容较多时显示滚动条 */
}

/* 当屏幕尺寸小于某个值时，为元素添加滚动条 */
@media (max-width: 600px) {
  .sectionBackGround {
    height: 300px;
    /* 设置一个固定高度或者最大高度 */
    overflow-y: scroll;
    /* 仅在垂直方向上显示滚动条 */
  }
}

/* 左上角返回按钮样式 */
.badge-icon {
  position: absolute;
  top: -30px;
  left: 25px;
  font-size: 24px;
  color: #fff;
  cursor: pointer;
}

ul.list-unstyled {
  margin-top: 10px !important;
}

.my-custom-class .container {
  padding-top: 1rem !important;
  padding-bottom: 0rem !important;
  height: auto !important;
}

.my-custom-class .pt-lg {
  padding-top: 1rem !important;
}

.doc-title {
  color: #333;
  font-family: 'Noto Sans S Chinese';
  font-size: 20px;
  font-style: normal;
  font-weight: 800;
  line-height: 40px;
  letter-spacing: 1px;
}

/* 小屏幕设备 */
@media (max-width: 600px) {
  .doc-title {
    font-size: 12px;
    font-weight: 500;

  }
}

.badge-icon i {
  margin-right: 8px;
  font-size: 14px;
}

.back-button-container span {
  font-size: 14px;
  color: gray;
}
</style>